import React from "react";
import { type PersistentNotification } from "../../api";
import { observer } from "mobx-react";
import { action, makeObservable } from "mobx";
import colors from "../colors.scss";
import { store } from "../../store";
import { routePath } from "../../route-path";
import {
    NotificationCard,
    NotificationTitle,
    NotificationRow,
    NotificationLink,
} from "./notification-item";

export type MaintenanceNotificationItemProps = {
    notification: PersistentNotification;
    markNotificationRead?: (id: string) => void;
};

@observer
export class MaintenanceNotificationItem extends React.Component<MaintenanceNotificationItemProps> {
    constructor(props: MaintenanceNotificationItemProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private markRead(): void {
        if (this.props.markNotificationRead) {
            this.props.markNotificationRead(this.props.notification.id);
        }
    }

    render(): JSX.Element {
        const notification = this.props.notification;
        const hoursUntilMaintenance = notification.hoursUntilMaintenance ?? 0;

        const vehicle = store.repositoryVehicles.byId(notification.vehicleId);
        if (!vehicle) {
            return <></>;
        }

        let title = store.i18n.t("component.notificationItemMaintenance.maintenanceDueTitle");
        let hoursUntilMaintenanceLabel = store.i18n.t(
            "component.notificationItemMaintenance.hoursUntilMaintenance",
        );
        let hoursUntilMaintenanceStyle = {};
        if (hoursUntilMaintenance <= 0) {
            title = store.i18n.t("component.notificationItemMaintenance.maintenanceOverdueTitle");
            hoursUntilMaintenanceLabel = store.i18n.t(
                "component.notificationItemMaintenance.maintenanceOverdueSince",
            );
            hoursUntilMaintenanceStyle = { color: colors["secondary11"] };
        }

        let departmentLabel = store.i18n.t(
            "component.notificationItemMaintenance.noTruckDepartment",
        );
        if (notification.truckDepartmentId) {
            const department = store.repositoryDepartments.byId(notification.truckDepartmentId);
            departmentLabel = department?.label ?? departmentLabel;
        }

        return (
            <NotificationCard markRead={!this.props.notification.read ? this.markRead : undefined}>
                <NotificationTitle to={routePath.impactManagement()}>{title}</NotificationTitle>
                <NotificationRow>
                    {store.i18n.formatDateTime(notification.triggeredAt)}
                </NotificationRow>
                <NotificationRow>
                    <span>{store.i18n.t("component.notificationItemImpact.truck")}:</span>
                    <NotificationLink to={routePath.vehicles()}>
                        {vehicle.serialNumber}
                    </NotificationLink>
                </NotificationRow>
                <NotificationRow>
                    <span>
                        {store.i18n.t("component.notificationItemMaintenance.truckDepartment")}:
                    </span>
                    <span>{departmentLabel}</span>
                </NotificationRow>
                <NotificationRow>
                    <span>{hoursUntilMaintenanceLabel}:&#32;</span>
                    <span style={hoursUntilMaintenanceStyle}>
                        {Math.abs(notification.hoursUntilMaintenance ?? 0)}h
                    </span>
                </NotificationRow>
            </NotificationCard>
        );
    }
}
